export default "__VITE_ASSET__C_x6dabC__"